import { createBrowserRouter } from 'react-router-dom'
import AlterarSenha from '../View/Controller/AlterarSenha'
import Clientes from '../View/Crud/Clientes'
import ErroAplicacao from '../Layout/ErroAplicacao'
import ExemploMenu from '../exemplo_apagar/menu'
import Grupos from '../View/Crud/Sistema/Grupos'
import Layout from '../Layout/Layout'
import Logout from '../View/Controller/Logout'
import SetCliente from '../View/Controller/SetCliente'
import TesteBox from '../exemplo_apagar/TesteBox'
import Usuarios from '../View/Crud/Sistema/Usuarios'
import ImportarRelat from '../View/Importacao/ImportarRelat'
import EnviarOS from '../View/Importacao/EnviarOS'
import RelatorioAmostras from '../View/Importacao/RelatorioAmostras'

// TODO - Novo Menu / Modulo 
export const router = createBrowserRouter( [
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErroAplicacao />,
    children: [
      {
        path: "ImportarRelat",
        element: <ImportarRelat />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "RelatorioAmostras",
        element: <RelatorioAmostras />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "EnviarOS",
        element: <EnviarOS />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "AlterarSenha",
        element: <AlterarSenha />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "Clientes",
        element: <Clientes />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "Grupos",
        element: <Grupos />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "Logout",
        element: <Logout />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "SetCliente",
        element: <SetCliente />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "Usuarios",
        element: <Usuarios />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "/TesteBoxComLogin",
        element: <TesteBox />
      }
    ]
  },
  {
    path: "/ErroAplicacao",
    element: <ErroAplicacao />
  },
  {
    path: "/ExemploMenu",
    element: <ExemploMenu />
  },
  {
    path: "/TesteBox",
    element: <TesteBox />
  },
] );